/**
 * Positions a manual dropdown menu inside the viewport. Uses FIXED
 * positioning with viewport coordinates (getBoundingClientRect), so it works
 * regardless of which element actually scrolls (window, body or an app-shell
 * content container). Clamps horizontally, flips above the trigger when
 * there is no room below, and caps the height with inner scrolling when the
 * menu is taller than the viewport.
 */
export function positionDropdown(dropdown, targetElement, preferredWidth = 200) {
    const rect = targetElement.getBoundingClientRect();
    const margin = 8;
    const vw = window.visualViewport?.width || window.innerWidth;
    const vh = window.visualViewport?.height || window.innerHeight;

    dropdown.style.position = 'fixed';
    dropdown.style.zIndex = '1050';
    dropdown.style.maxHeight = '';
    dropdown.style.overflowY = '';

    // Measure the real rendered size (the element is already in the DOM).
    const w = dropdown.offsetWidth || preferredWidth;
    let h = dropdown.offsetHeight || 0;

    // Taller than the viewport → cap and scroll inside the menu.
    if (h > vh - 2 * margin) {
      h = vh - 2 * margin;
      dropdown.style.maxHeight = `${h}px`;
      dropdown.style.overflowY = 'auto';
    }

    // Horizontal: align to the trigger, clamp into the viewport.
    const left = Math.max(margin, Math.min(rect.left, vw - w - margin));

    // Vertical: below the trigger; flip above when there is no room below;
    // pin to the bottom edge when neither side has room.
    let top = rect.bottom + 6;
    if (top + h > vh - margin) {
      const above = rect.top - h - 6;
      top = above >= margin ? above : Math.max(margin, vh - h - margin);
    }

    dropdown.style.top = `${top}px`;
    dropdown.style.left = `${left}px`;
  }